import { Link } from 'react-router-dom';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { OwlLogo } from '../components/ui/OwlLogo';

export function NotFoundPage() {
  return (
    <Card className="flex flex-col items-center gap-4 p-8 text-center">
      <OwlLogo size={72} />
      <h1 className="text-3xl font-semibold">404</h1>
      <p className="text-sm text-text-muted">Такой страницы нет. Совёнок не нашёл её в книгах.</p>
      <Link to="/dashboard">
        <Button size="lg">На главную</Button>
      </Link>
    </Card>
  );
}
